import rules from "@/utils/inputRules";
import { translation } from "@/utils/service/Translations/translations";
import {isFalse, isTrue} from "@/utils/service/DocumentGeneration/answers";
import {TERMS_OF_SERVICE} from "@/utils/service/documents";

export default [
    {
        name: "General Information",
        inputs: [
            {
                model: "company.name",
                type: "businessName",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                model: "company.email",
                type: "email",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                model: "website_url",
                type: "websiteUrl",
                classes: "col-md-6",
                rules: [rules.required, rules.url],
            },
            {
                model: "company.address",
                type: "address",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                label: "Phone number for the refunds related questions",
                model: "company.phone",
                type: "phone",
                input: {
                    global: false,
                },
                rules: [rules.required],
            },
        ],
        actions: [
            {
                component: () => import("@/components/Projects/Project/ProjectGeneralInformationUpdateOnDocumentCreate.vue"),
                params: (self) => ({
                    color: "secondaryDark",
                    text: true,
                    class: "th-mr-12",
                    to: {
                        name: "project_index",
                        params: self?.$route.params,
                    },
                }),
                cta: "Edit project information",
            },
        ]
    },
    {
        name: "Terms of Services",
        inputs: [
            {
                title:
                    "Do you have Terms of Service (also known as Terms and Conditions and Terms of Use) on your website?",
                model: "has_terms_of_services",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) => isTrue(model["has_terms_of_services"]),
                title: "Please insert the link to your Terms of Service",
                model: "has_terms_of_services_link",
                type: "projectDocument",
                policyType: TERMS_OF_SERVICE,
            },
            {
                condition: (model) => isFalse(model["has_terms_of_services"]),
                type: "custom",
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                input: {
                    title: `We strongly recommend that you include a Terms of Service on your website`,
                },
            },
            {
                condition: (model) => isFalse(model["has_terms_of_services"]),
                model: "tos_no_use_create",
                type: "projectDocumentCreateSuggest",
                policyType: TERMS_OF_SERVICE,
            },
        ],
    },
    {
        name: "Prekių grąžinimas",
        inputs: [
            {
                title: "Are your all goods eligible for refund?",
                tooltip:
                    'If you have discounted or other types of goods which are not eligible for refund, select "No"',
                model: "all_goods_refundable",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) => model["all_goods_refundable"] === "false",
                model: "refundable_goods_type",
                type: "radio",
                default: "defective",
                values: {
                    defective: "Only defective",
                    some: "Only some (you have the exceptions)",
                },
            },
            {
                condition: (model) =>
                    model["all_goods_refundable"] === "false" &&
                    model["refundable_goods_type"] === "some",
                model: "non_refundable_goods",
                type: "multiSelect",
                label: "Please select all exceptions applicable to you",
                default: [],
                values: [
                    "Supakuotų prekių, kurios buvo išpakuotos po pristatymo ir kurios yra netinkamos grąžinti dėl sveikatos apsaugos ar higienos priežasčių",
                    "Pagal specialius Kliento nurodymus pagamintų prekių, kurios nebuvo iš anksto pagamintos ir kurios gaminamos atsižvelgiant į Kliento asmeninį pasirinkimą",
                    "Greitai gendančių prekių arba prekių, kurių galiojimo laikas yra trumpas",
                    "Prekių, kurios po pristatymo dėl savo pobūdžio neatskiriamai susimaišo su kitais daiktais",
                    "Supakuotų vaizdo ar garso įrašų arba supakuotos programinės įrangos, kuri buvo išpakuota po pristatymo",
                    "Alkoholinių gėrimų, kurių kaina nustatyta sudarant pirkimo-pardavimo sutartį ir kurie pristatomi po trisdešimt dienų nuo sutarties sudarymo, o tikroji gėrimų vertė priklauso nuo rinkos svyravimų",
                    "Paslaugų, kurias Klientas užsako pateikdamas konkretų prašymą Jums dėl Jūsų darbuotojų atvykimo tam, kad būtų atlikti skubaus remonto ar priežiūros darbai",
                    "Laikraščių, bei užsakymų dėl periodinių leidinių ar žurnalų pristatymo,",
                    "Apgyvendinimo, prekių vežimo, automobilių nuomos, viešojo maitinimo ar laisvalaikio paslaugų (taikoma jeigu sutartyje yra nustatyta konkreti paslaugų teikimo data ar laikotarpis)",
                    "Užsakymų dėl skaitmeninio turinio teikimo (taikoma jeigu skaitmeninio turinio teikimas buvo pradėtas Klientui iš anksto aiškiai sutikus ir pripažinus, kad dėl to jis praras teisę atsisakyti sutarties)",
                ],
            },
            {
                condition: (model) =>
                    model["all_goods_refundable"] === "false" &&
                    model["refundable_goods_type"] === "some",
                model: "non_refundable_goods_other",
                type: "addOption",
                label: "Other",
                addLabel: "Enter other types of non-refundable goods",
                inline: true,
                default: [],
                options: [],
            },
        ],
        validate: (model) => {
            if (
                model["all_goods_refundable"] === "false" &&
                model["refundable_goods_type"] === "some"
            ) {
                return model["non_refundable_goods"].concat(
                    model["non_refundable_goods_other"]
                ).length > 0
                    ? ""
                    : translation.t(
                          "At least one has to be selected or entered"
                      );
            }

            return null;
        },
    },
    {
        name: "Term for refund",
        inputs: [
            {
                title: "How long does a buyer have to request a refund?",
                model: "refund_period",
                type: "radio",
                default: "14",
                values: {
                    14: "14 days",
                    30: "30 days",
                    other: "Other",
                },
            },
            {
                condition: (model) => model["refund_period"] === "other",
                model: "refund_period_other",
                type: "text",
                inputType: "number",
                rules: [rules.required],
            },
        ],
    },
    {
        name: "Ways to ask for refund",
        inputs: [
            {
                title: "How does a buyer have to request a refund?",
                model: "refund_process",
                type: "multiSelect",
                result: "object",
                values: {
                    contact_support: "Buyer must contact your Support team",
                    submit_return_form:
                        "Buyer must send back the Return form received with the goods",
                    return_to_address:
                        "Buyer must send back the good to the address provided in Refund Policy",
                },
            },
            {
                condition: (model) =>
                    model["refund_process"]?.return_to_address === true,
                model: "refund_process_return_address",
                type: "custom",
                input: {
                    showState: false
                },
                component: () =>
                    import(
                        "@/components/Documents/RefundPolicy/RefundPolicyReturnAddress.vue"
                    ),
            },
            {
                model: "refund_process_other",
                type: "addOption",
                label: "Other",
                addLabel: "Enter other types for requesting refund",
                inline: true,
                default: [],
                options: [],
            },
        ],
        validate: (model) => {
            return Object.values(model["refund_process"])
                .filter((v) => v)
                .concat(model["refund_process_other"]).length > 0
                ? ""
                : translation.t("At least one has to be selected or entered");
        },
    },
    {
        name: "Shipping costs",
        inputs: [
            {
                title:
                    "Ar grąžinate Klientui visas su Prekių pristatymu susijusias išlaidas?",
                model: "return_cost_covered_by_company",
                type: "radio",
                default: "false",
                values: {
                    false: "Ne (tik už pigiausią pasiūlytą pristatymo būdą)",
                    true: "Yes",
                },
            },
        ],
    },
    {
        name: "Money back term",
        inputs: [
            {
                title:
                    "How long does a buyer have to wait for a refund after the goods are returned?",
                model: "refund_issue_period",
                type: "radio",
                default: "14",
                values: {
                    14: "14 days",
                    30: "30 days",
                    other: "Other",
                },
            },
            {
                condition: (model) => model["refund_issue_period"] === "other",
                model: "refund_issue_period_other",
                type: "text",
                inputType: "number",
                rules: [rules.required],
            },
        ],
    },
    {
        name: "Defective goods",
        inputs: [
            {
                title:
                    "What information buyer must provide in case the goods are defected?",
                model: "required_defective_goods_info",
                type: "multiSelect",
                default: ["Užsakymo numerį"],
                values: [
                    "Užsakymo numerį",
                    "Sąskaitos faktūros numerį",
                    "Prekės arba paslaugos pavadinimą",
                    "Informaciją apie Prekės trūkumus, trūkstamas dalis ar pažeidimus",
                    "Informaciją apie paslaugos trūkumus",
                    "Prekės trūkumų įrodymus (pvz. nuotraukas arba video, kuriose būtų matomas prekės trūkumas (jei tai yra įmanoma), taip pat nuotraukas arba video su pakuotės pažeidimais ar kt.)",
                ],
            },
            {
                model: "required_defective_goods_info_other",
                type: "addOption",
                label: "Other",
                addLabel: "Enter other required information",
                inline: true,
                default: [],
                options: [],
            },
        ],
        validate: (model) => {
            return model["required_defective_goods_info"].concat(
                model["required_defective_goods_info_other"]
            ).length > 0
                ? ""
                : translation.t("At least one has to be selected or entered");
        },
    },
    {
        name: "Complaint resolution",
        inputs: [
            {
                title: "What ways you can offer to resolve the claim?",
                model: "complaint_resolution_methods",
                type: "multiSelect",
                validate: (model) =>
                    model.length > 0
                        ? ""
                        : translation.t("At least one has to be selected"),
                default: [],
                values: [
                    "pakeisti nekokybišką Prekę į identišką geros kokybės Prekę;",
                    "nekokybiškai Prekei pritaikyti nuolaidą, atitinkančią Prekės vertės sumažėjimą, sąlygotą esamų trūkumų;",
                    "prekę priimti ir grąžinti Klientui sumokėtus pinigus;",
                    "nutraukti paslaugą ir grąžinti Klientui sumokėtus pinigus;",
                    "sutaisyti Prekę ar kitaip pašalinti prekės ar paslaugos trūkumus.",
                ],
            },
        ],
    },
];
